import useParamsLocale from '#/data/useParamsLocale';
import { format, formatDistanceToNowStrict } from 'date-fns';
import { Tooltip, TooltipContent, TooltipTrigger } from './ui/tooltip';

interface Props {
  date?: number | Date | null;
}

export default function DistanceToNow({ date }: Props) {
  const locale = useParamsLocale();
  return date != null ? (
    <Tooltip>
      <TooltipTrigger className="truncate">
        {formatDistanceToNowStrict(date, { locale, addSuffix: true })}
      </TooltipTrigger>
      <TooltipContent>
        {format(date, 'PP, HH:mm:ss', { locale })}
      </TooltipContent>
    </Tooltip>
  ) : (
    <>-</>
  );
}
